(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kof-collection"]) return;
  try {
    
  // Sort — update sort_by URL param while preserving all other params
  const kofSortSelect = document.getElementById('KofSortBy');
  if (kofSortSelect) {
    // Shrink the <select> to fit the SELECTED option so there is no trailing
    // whitespace from the longest option determining the width.
    const kofSizeSort = () => {
      const opt = kofSortSelect.options[kofSortSelect.selectedIndex];
      if (!opt) return;
      const cs = getComputedStyle(kofSortSelect);
      const probe = document.createElement('span');
      probe.style.position = 'absolute';
      probe.style.visibility = 'hidden';
      probe.style.whiteSpace = 'pre';
      probe.style.fontFamily = cs.fontFamily;
      probe.style.fontSize = cs.fontSize;
      probe.style.fontWeight = cs.fontWeight;
      probe.style.fontStyle = cs.fontStyle;
      probe.style.letterSpacing = cs.letterSpacing;
      probe.style.textTransform = cs.textTransform;
      probe.textContent = opt.text;
      document.body.appendChild(probe);
      kofSortSelect.style.width = Math.ceil(probe.getBoundingClientRect().width + 2) + 'px';
      probe.remove();
    };
    kofSizeSort();

    kofSortSelect.addEventListener('change', function () {
      kofSizeSort();
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // Filter panel toggle
  const kofFilterBtn = document.querySelector('.kof-collection__filter-btn');
  const kofFilterPanel = document.getElementById('KofFilterPanel');
  if (kofFilterBtn && kofFilterPanel) {
    kofFilterBtn.addEventListener('click', function () {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!isExpanded));
      kofFilterPanel.hidden = isExpanded;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kof-featured-products"] && !Shopify.designMode) return;
  try {
    
  class KofFeaturedProducts extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.kof-featured-products__tab'));
      this.panels = Array.from(this.querySelectorAll('.kof-featured-products__panel'));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(index));
      });
    }

    activate(index) {
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('is-active', i === index);
        tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      this.panels.forEach((panel, i) => {
        panel.classList.toggle('is-active', i === index);
      });
    }
  }

  customElements.define('kof-featured-products', KofFeaturedProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kof-product"]) return;
  try {
    
  class KofProduct extends HTMLElement {
    connectedCallback() {
      this._sid = this.dataset.section;

      // Canonical form inputs
      this._variantInput  = document.getElementById('kof-variant-id-' + this._sid);
      this._quantityInput = document.getElementById('kof-quantity-'   + this._sid);
      this._priceEl       = document.getElementById('kof-price-'      + this._sid);
      this._priceStickyEl = document.getElementById('kof-price-sticky-' + this._sid);
      this._gallery       = document.getElementById('kof-gallery-'    + this._sid);

      // Parse variant data
      const dataEl = document.getElementById('kof-variant-data-' + this._sid);
      this._variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      this._variantMap = {};
      this._variants.forEach(v => { this._variantMap[v.id] = v; });

      // Bind all qty steppers (desktop + mobile)
      this.querySelectorAll('.kof-qty-stepper').forEach(stepper => {
        stepper.querySelector('[data-qty-action="decrease"]')
          .addEventListener('click', () => this._adjustQty(-1));
        stepper.querySelector('[data-qty-action="increase"]')
          .addEventListener('click', () => this._adjustQty(+1));
      });

      // Bind all variant selects (desktop + mobile)
      this.querySelectorAll('.kof-variant-select').forEach(sel => {
        sel.addEventListener('change', e => this._onVariantChange(e.target));
      });

      this._initSizeChart();
    }

    _initSizeChart() {
      this._sizeChart = this.querySelector('.kof-size-chart');
      if (!this._sizeChart) return;

      this.querySelectorAll('[data-kof-size-chart-open]').forEach(btn => {
        btn.addEventListener('click', () => this._openSizeChart());
      });

      this._sizeChart.querySelectorAll('[data-kof-size-chart-close]').forEach(el => {
        el.addEventListener('click', () => this._closeSizeChart());
      });

      this._sizeChart.querySelectorAll('[data-kof-sc-tab]').forEach(tab => {
        tab.addEventListener('click', () => this._activateSizeChartTab(tab.dataset.kofScTab));
      });

      this._onSizeChartKeydown = (e) => {
        if (e.key === 'Escape' && !this._sizeChart.hidden) this._closeSizeChart();
      };
      document.addEventListener('keydown', this._onSizeChartKeydown);
    }

    _openSizeChart() {
      this._sizeChart.hidden = false;
      document.body.style.overflow = 'hidden';
      const firstTab = this._sizeChart.querySelector('.kof-size-chart__tab');
      if (firstTab) firstTab.focus();
    }

    _closeSizeChart() {
      this._sizeChart.hidden = true;
      document.body.style.overflow = '';
    }

    _activateSizeChartTab(key) {
      this._sizeChart.querySelectorAll('[data-kof-sc-tab]').forEach(tab => {
        const active = tab.dataset.kofScTab === key;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this._sizeChart.querySelectorAll('[data-kof-sc-panel]').forEach(panel => {
        const active = panel.dataset.kofScPanel === key;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }

    _adjustQty(delta) {
      let qty = parseInt(this._quantityInput.value, 10) || 1;
      qty = Math.max(1, qty + delta);
      this._quantityInput.value = qty;
      this.querySelectorAll('.kof-qty-display').forEach(el => {
        el.textContent = qty;
      });
    }

    _onVariantChange(changedSelect) {
      const id = parseInt(changedSelect.value, 10);

      if (this._variantInput) this._variantInput.value = id;

      this.querySelectorAll('.kof-variant-select').forEach(sel => {
        if (sel !== changedSelect) sel.value = id;
      });

      const vData = this._variantMap[id];
      if (vData) {
        if (this._priceEl)       this._priceEl.textContent       = vData.price;
        if (this._priceStickyEl) this._priceStickyEl.textContent = vData.price;
      }

      if (vData && vData.image_id != null && this._gallery) {
        const target = this._gallery.querySelector('[data-image-id="' + vData.image_id + '"]');
        if (target) {
          this._gallery.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
        }
      }
    }
  }

  customElements.define('kof-product', KofProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kof-related-products"]) return;
  try {
    
  class KofCarousel extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-kof-scroller]');
      if (!this.scroller) return;

      this.buttons = this.querySelectorAll('[data-kof-dir]');
      this.buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const amount = this.scroller.clientWidth * 0.8 * Number(btn.dataset.kofDir);
          this.scroller.scrollBy({ left: amount, behavior: 'smooth' });
        });
      });

      this.updateNav = this.updateNav.bind(this);
      this.scroller.addEventListener('scroll', this.updateNav, { passive: true });
      window.addEventListener('resize', this.updateNav, { passive: true });
      this.updateNav();
    }

    updateNav() {
      const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth - 1;
      this.buttons.forEach((btn) => {
        if (Number(btn.dataset.kofDir) < 0) {
          btn.disabled = this.scroller.scrollLeft <= 0;
        } else {
          btn.disabled = this.scroller.scrollLeft >= maxScroll;
        }
      });
    }
  }

  if (!customElements.get('kof-carousel')) {
    customElements.define('kof-carousel', KofCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
